/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![StagePlusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACxklEQVR4nMVVSWsUURCOl7gR14MaVARRwZ/gFkUCg+lXVR14UzVGmRgwQTyoCIqKgig63vwb6sH1FFAwwYMEXE8KQYUk3sQtapQkUt3VnSbTmSwebGiYevOqvq++Wrqu7n8+3vuljvgIEN8Gkg8O5RuQ/AHkfkd8D0gOt7TsXz7rwE3l8gIgvgAkw0AyXut1KJ8d8vlCoTB/RsEReZ0jfmUBxgC52yG3t7SWNgVBsMh7v5CINwNJByA/TIGI+xB5Q83gQeDXA8mAMXsTUGnHDAjt1LsREPL7MGxbm3tRmTniZzEbeaz66zmANDqUq4Dy2iH/digjmqFDubzP+9UxSHmZI+mxTJ577+urAEzziHkaPCyKI/k6dQ34CyJzCmKZaE0ms19hHTKGyNvS4MijxuouIu8uFNqWNDcfWKy/rYs02GgCElCpSWNo4QGgIaNjqcs07FY7DNvWJMwdyqmp9HfIZ5NMnJNV0RnJIyPVOSEPyn3TvhzbfCUGlDuWYT0QX3PIQ454EEgqic6pL/KlWGrpMN+bE0xI3ukhEW+MbWtTKO4yp0pODSpxExT3WMAXse23mBr9mQz4px4mw+JQfqitfW9SDFUBoHyMA0KDnQ2rrTVKZMt0kPzSQ23VLIBetowGczIYSBUIpTmzMubFDcPfqyTSabWWfRllgLx3Kol0NmoU/zQgv80AWMtZkXWIokChHJ0oslQ0k8lFzpB8Asi9sWzS6IhvZQE6s21KdHClIzkzm02ZZJbJoj39UwPZoI271uL2nM16zCE/tTXRNxOAnAt8zrS9nt2sYPXIaH98TgDK1KFcBPBb1daWzazt9NW1kmo+zbciqUnuo0zznLQ+EWPk3mk/RiQ9NQD4Qa4jyIk5SVQFQIw6LDn9P+JQTiaZzBkgctI1AMVDuvR01+sHB4g/RYOJfEMX2z8BzIoMcm+e5n8BHDMRmqymWHAAAAAASUVORK5CYII=)
 */
export const StagePlusIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M22.29 15.9a.15.15 0 0 1-.29-.05V15c0-.81-.32-1.55-.85-2.09a.57.57 0 0 1-.16-.42L21 12a9 9 0 1 0-16.54 4.92c.27.42.26.97-.07 1.33l-.02.02c-.41.44-1.12.43-1.46-.07a11 11 0 1 1 19.37-2.3Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M12.72 17.05c.3-.35.2-1-.25-1.03a6 6 0 0 0-6.14 4.01c-.25.72.12 1.5.8 1.84a10.96 10.96 0 0 0 8.78.42c.05-.03.09-.08.09-.14a.15.15 0 0 0-.15-.15H15a3 3 0 0 1-2.28-4.95ZM19 12a7 7 0 1 0-13.28 3.09c.27.56 1.02.6 1.45.14l.05-.06c.3-.33.35-.81.17-1.23A4.98 4.98 0 0 1 12 7a5 5 0 0 1 5 5c0 .27.37.47.6.34.42-.22.9-.34 1.4-.34Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM19 14a1 1 0 0 1 1 1v3h3a1 1 0 1 1 0 2h-3v3a1 1 0 1 1-2 0v-3h-3a1 1 0 1 1 0-2h3v-3a1 1 0 0 1 1-1Z"
        className={colorClass}
      />
    </svg>
  );
};
